import SurveySubmitted from './SurveySubmitted'

export default SurveySubmitted